import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  AutoAwesome as AutoAwesomeIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { useTranslationApp } from "../../../../lib/i18next";
import { BUTTON_CLOSE } from "../../../../i18n/keysTranslations";
import ImageActions from "../single/ImageActions";

const ImageEditTopBar = ({
  title,
  imageUrl,
  initialImageUrl,
  onCallbackSave,
  onClose,
  onCloseAfterSave,
  showSaveAlert = true,
  saveDisabled,
  actions = null,
}) => {
  const theme = useTheme();
  const { t } = useTranslationApp();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        px: { xs: 1.5, sm: 2 },
        py: 1.25,
        minHeight: 64,
        borderBottom: "1px solid #E0E0E0",
        bgcolor: "background.paper",
        flexShrink: 0,
        zIndex: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flex: 1,
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            p: 1.25,
            bgcolor: "primary.main",
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <AutoAwesomeIcon sx={{ color: "#ffffff !important", fontSize: 20 }} />
        </Box>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flexShrink: 0,
        }}
      >
        {actions}
        {!actions && imageUrl ? (
          <ImageActions
            variant="compact"
            imageUrl={imageUrl}
            initialImageUrl={initialImageUrl}
            onCallbackSave={onCallbackSave}
            onClose={onCloseAfterSave}
            showSaveAlert={showSaveAlert}
            disabled={saveDisabled}
          />
        ) : null}
        <IconButton
          className="close-modal-button"
          aria-label={t(BUTTON_CLOSE)}
          onClick={onClose}
          sx={{
            p: 0.5,
            fontSize: "1.4rem",
            color: "background.paperSecondaryContrastText",
            backgroundColor: "background.paperSecondary",
            "&:hover": {
              color: "background.paperSecondaryContrastText",
              backgroundColor: "background.paperSecondary",
              filter: theme.palette.hover.main,
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ImageEditTopBar;
